module.exports = __webpack_public_path__ + "img/interpackmaxi-active.c609c40c.svg";